import React from "react";
import "./index.css";

function NewBranchBanner() {
  return (
    <div className="new-branch-outer">
      <img className="new-branch-pattern" src="/img/new-branch-pattern.svg" />
      <div className="new-branch-inner">
        <h1 className="new-branch-title">
          New Branch Opening in Tanur, Malappuram!
        </h1>
        <p className="new-branch-thrilled">
          We are thrilled to announce the opening of our new branch in Tanur,
          Malappuram. As part of our commitment to providing quality healthcare
          services, this new location is equipped with state-of-the-art
          facilities and a dedicated team of medical professionals.
        </p>
        <div>
          <a href="mailto:tanur@sabinehospitals.com">
            <div className="new-branch-contact">
              <img src="/img/mail-white.svg" />

              <p>tanur@sabinehospitals.com</p>
            </div>
          </a>
          <a href="tel:+914943508200">
            <div className="new-branch-call">
              <img src="/img/call-white.svg" />

              <p>+91 494 350 8200</p>
            </div>
          </a>
        </div>
        <button
          onClick={() => window.open("https://g.co/kgs/S1ZyDct", "_blank")}
          className="location-button"
        >
          <img src="/img/map-blue.svg" />
          <p>Location</p>
          <img src="/img/arrow-blue.svg" />
        </button>
        <button
          onClick={() => window.open("https://g.co/kgs/S1ZyDct", "_blank")}
          className="location-button-mobile"
        >
          <img src="/img/map-blue.svg" />
          <p>Location</p>
          <img src="/img/arrow-blue.svg" />
        </button>
      </div>
    </div>
  );
}

export default NewBranchBanner;
